import { SESSION_STORAGE } from './constants';

const initializeApp = async () => {
  window['__ANOVA-VARS__'] = window['__ANOVA-VARS__'] || {};
  const { initializeGlobalVars } = await import('@anova/crude-vars');
  initializeGlobalVars();

  // @ts-ignore
  window.MICRO_FRONTEND = true;

  const [renderer, appModule] = await Promise.all([
    import('./shared/modules/renderer'),
    import('./App'),
  ]);

  // Save PostHog Toolbar info before
  const toolbarJSON = new URLSearchParams(
    window.location.hash.substring(1)
  ).get('__posthog');
  if (toolbarJSON) {
    window.sessionStorage.setItem(
      SESSION_STORAGE.POST_HOG_TOOLBAR,
      toolbarJSON
    );
  }

  const baseRenderer = renderer.default;
  const App = appModule.default;
  baseRenderer(App);
};

// TODO: debt related to useConciliateTreeCache from @anova/fuel-tree. To avoid the dependency of this package here
// and the lack of time, we are hardcoding these ids here for now. To be fixed asap
sessionStorage.removeItem('TREE_NODE_CACHE_CONCILIATION');
sessionStorage.removeItem('RENDERED_TREES');

initializeApp();

/**
 * @exports
 * Initialization method for testing purposes
 */
export const testInit = initializeApp;

export default undefined;
